Ext.define('SA.CoalescingMicroTask', {
    statics: {
        coalesce(callback) {
            var task = new SA.CoalescingMicroTask(callback);

            return () => task.queue();
        }
    },

    constructor(callback) {
        this.callback = callback;
        this.hasTask = false;
    },

    perform() {
        this.hasTask = false;
        this.callback();
    },

    queue() {
        if (this.hasTask) {
            return;
        }

        this.hasTask = true;
        queueMicrotask(() => this.perform());
    }
});